import { render, staticRenderFns } from "./smart-cover.vue?vue&type=template&id=b7ab9170&scoped=true"
import script from "./smart-cover.vue?vue&type=script&lang=js"
export * from "./smart-cover.vue?vue&type=script&lang=js"
import style0 from "./smart-cover.vue?vue&type=style&index=0&id=b7ab9170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab9170",
  null
  
)

export default component.exports